import UserPreferencesModalBlock from './UserPreferencesModalBlock';

export default UserPreferencesModalBlock;
